var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-mod-container"},[_c('div',{staticClass:"shareBg"},[_c('img',{staticClass:"close",attrs:{"src":require("../img/closeModal.png"),"alt":""},on:{"click":_vm.close}})])])}
var staticRenderFns = []

export { render, staticRenderFns }